module.exports = __webpack_public_path__ + "img/promotion-check-mark.95e19632.svg";